import { base } from './environment.base'

const { local, staging, demo } = base

export const environment = {
  ...base,
  RECURLY_JS_API_KEY: staging || demo || local ? 'sjc-NSn88YBx7hxxUX5zTvM0Ff' : 'sjc-C0m1L8keUn7IQyQFJdtS3o',
  production: true,
  test: false,
  demo: demo,
  ROLLBAR_ACCESS_TOKEN: 'b9a46ae37e564167b39da6f610f09ac4',
  env: staging ? 'staging' : ( demo ? 'demo' : ( local ? 'local-prod-build' : 'production' ) ),
  gitVersion: "7e5ce86fbdf5348a8d428c74b7e093679288b880"
}
